import { Skeleton } from "antd";
import CertificateInfoLoading from "./CertificateInfoLoading";
import CourseItemListLoading from "./CourseItemListLoading";

export default function CourseOverviewLoading() {
  return (
    <div className="space-y-6">
      <Skeleton.Image
        active
        className="!w-full md:!h-[25rem] !h-64 rounded-xl"
      />

      <CourseItemListLoading />

      <div className="grid md:grid-cols-2 gap-6">
        <CourseItemListLoading />
        <CourseItemListLoading />
      </div>

      <CertificateInfoLoading />
    </div>
  );
}
